import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchProducts = (params = {}) =>
    api.get("/products", { params }).then((r) => r.data);

export const fetchProduct = (slug) =>
    api.get(`/products/${slug}`).then((r) => r.data);

export const postAppointment = (payload) =>
    api.post("/appointments", payload).then((r) => r.data);

export const postEnquiry = (payload) =>
    api.post("/enquiries", payload).then((r) => r.data);

export const fetchAdminAppointments = (key) =>
    api.get("/appointments", { params: { key } }).then((r) => r.data);

export const fetchAdminEnquiries = (key) =>
    api.get("/enquiries", { params: { key } }).then((r) => r.data);

export const fetchShopifyProducts = (params = {}) =>
    api.get("/shopify/products", { params }).then((r) => r.data);

export const fetchShopifyProduct = (handle) =>
    api.get(`/shopify/products/${handle}`).then((r) => r.data);

export const openBooking = (interest) =>
    window.dispatchEvent(new CustomEvent("bsk:book", { detail: { interest } }));

export const openSearch = () =>
    window.dispatchEvent(new CustomEvent("bsk:search"));

const WISHLIST_KEY = "bsk_wishlist";

export const getWishlist = () => {
    try {
        return JSON.parse(localStorage.getItem(WISHLIST_KEY) || "[]");
    } catch {
        return [];
    }
};

export const toggleWishlistItem = (product) => {
    const list = getWishlist();
    const exists = list.find((p) => p.slug === product.slug);
    const next = exists
        ? list.filter((p) => p.slug !== product.slug)
        : [...list, { slug: product.slug, name: product.name, image: product.image, category: product.category }];
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(next));
    window.dispatchEvent(new CustomEvent("bsk:wishlist"));
    return !exists;
};

export const isWishlisted = (slug) => getWishlist().some((p) => p.slug === slug);
